/**
 * Returns true when running in development (NODE_ENV === "development").
 * Useful for conditional debug UI, logging, or dev-only features.
 */
export function useIsDev(): boolean {
  return process.env.NODE_ENV === "development";
}
